<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <npc :npc-id="0">⋯⋯真想不到會被關到以前的彰化警察署呢。</npc>
              <npc :npc-id="1" right>有什麼好想不到的？</npc>
              <npc :npc-id="0">這也是跟賴和先生有因緣的地方，他曾被關在這，是二戰期間的事，當時警察也是毫無理由就羈押他呢。</npc>
              <npc :npc-id="1" right>我知道，那本有名的《獄中日記》就是在這裡寫的吧？但現在不是關心這種事的時候吧！</npc>
              <npc :npc-id="0">因為就算著急也沒用嘛。</npc>
              <npc :npc-id="1" right>我真不懂你怎麼能這麼輕鬆，要是一個弄不好，我們可能永遠無法回到原來的時空耶！你沒發現這個彰化警察署很奇怪嗎？</npc>

              <story-image :src="require(`@/assets/images/pics/第5章_3-1_水牢畫圖.jpg`)" size="lg"></story-image>
              <!-- （圖片：水牢） -->

              <npc :npc-id="0">沒錯，這個彰化警察署大概是漂流在不同時空中吧？既不是我們的時空，也不是那個時空警察的時空，不是現代，也不完全是過去。</npc>
              <npc :npc-id="1" right>對啊，或許我們無法回到現在耶！你怎麼不著急？</npc>
              <npc :npc-id="0">因為憑我們的力量，沒辦法逃出去啊。</npc>
              <npc :npc-id="1" right>難道你要放棄？</npc>
              <npc :npc-id="0">不，我不打算放棄。只是我在思考更重要的問題。</npc>
              <npc :npc-id="1" right>什麼問題？</npc>
              <npc :npc-id="0">剛剛那個警察說的話⋯⋯你不覺得很不公平嗎？</npc>
              <npc :npc-id="1" right>啊？</npc>
              <npc :npc-id="0">『臺灣新文學之父』這個稱號，確實是後人給的，但除了賴和先生以外，還有誰值得這個稱號？</npc>
              <npc :npc-id="1" right>⋯⋯</npc>
              <npc :npc-id="0">不是這樣嗎？賴和先生在新文學運動的潮流中，不只是推廣白話文，還刻意使用臺灣話，這在當代都是罕見的努力耶！而且那個警察說賴和先生的作品不成熟，拜託，那時臺灣人才剛開始用白話文寫小說，當然比不上現代的技法，更別說賴和先生還用心培養後進，花錢資助年輕作家、保留臺灣民俗，那個警察根本什麼都不懂——</npc>
              <npc :npc-id="1" right>好了，呂善安，我知道你很生氣，但現在真的不是思考這個的時候吧！</npc>
              <npc :npc-id="0">不，現在正是時候。</npc>
              <npc :npc-id="1" right>不不不，現在應該想想該怎麼逃出去⋯⋯</npc>
              <npc :npc-id="0">放心吧。小蘇，你不覺得奇怪嗎？為何這個時空警察穿著日本時代的衣服？</npc>
              <npc :npc-id="1" right>確實有點奇怪，他應該來自未來吧？</npc>
              <npc :npc-id="0">對啊。而且那種形象、態度，你不覺得跟賴和先生筆下的日本警察很像嗎？</npc>
              <npc :npc-id="1" right>跟賴和筆下很像⋯⋯你是說像〈一桿秤仔〉裡的那樣？</npc>
              <npc :npc-id="0">對啊，蠻橫霸道，毫不講理。雖然我們覺得警察是維持秩序的，但對賴和先生來說，那就是殖民者帶來的東西，是壓迫臺灣人的體制之一。</npc>
              <npc :npc-id="1" right>賴和曾經歷過『治警事件』，只是參加集會就被警察粗暴地逮捕，會這麼想也理所當然吧。</npc>
              <npc :npc-id="0">對，但為何時間警察的形象這麼類似賴和先生的作品？我認為這是因為警察不得不遵守某些規則，看到這個飄移在特定時空之外的彰化警察署，我就更確定了。</npc>
              <npc :npc-id="1" right>這是怎麼一回事？</npc>
              <npc :npc-id="0">恐怕怪盜引起的時間變動只圍繞在賴和先生身上，所以追查怪盜的時間警察，為了避免干涉其他時空變數，只能透過與賴和先生有關的材料現身；他甚至不能把我們關到未來的監獄，只能把我們關在曾經關過賴和先生的地方！這裡不是哪個時空的彰化警察署，而是跟賴和先生有關的材料中剪輯出來的片段。</npc>
              <npc :npc-id="1" right>什麼意思？是說我們被困在虛構創作之中？</npc>
              <npc :npc-id="0">或是說，我們被困不同時空對賴和先生的不同想像裡。雖然時空警察說賴和先生微不足道，但為了對付怪盜，他必須依靠賴和先生，或是與他相關的歷史想像才能困著我們——而且我還發現了另一件事。</npc>
              <npc :npc-id="1" right>什麼？</npc>
              <npc :npc-id="0">怪盜的目的不是要偷走賴和先生的歷史，也不是要偷走臺灣文學館——正相反，他是要把被抹去的歷史給偷回來。</npc>
              <npc :npc-id="1" right>什麼！？</npc>

              <story-image :src="require(`@/assets/images/pics/第5章_3-2_水牢畫圖_發光.jpg`)" size="lg"></story-image>
              <!-- （圖片，水牢的景色發出奇異的光芒） -->

              <p class="text-center mb-5">（水牢裡發出奇異的藍光，空中浮現九扇窗戶）</p>

              <story-image :src="require(`@/assets/images/pics/第5章_3-3_警察署九宮格_警察署.jpg`)" size="lg"></story-image>
              <story-image :src="require(`@/assets/images/pics/第5章_3-4_水牢紙條.jpg`)" size="md"></story-image>
              <!-- （謎題圖片，九宮格與一張紙條） -->

              <npc :npc-id="1" right>這是⋯⋯！</npc>
              <npc :npc-id="0">是怪盜的留言，他來幫我們逃獄了。</npc>
              <npc :npc-id="1" right>『我為你們打開了九門迷宮，眾多通道中，找出彰化警察署的通道，即可逃生』⋯⋯空中憑空出現了九個通道，呂善安！</npc>
              <npc :npc-id="0">嗯，選出正確的通道吧！答案或許不只一個！</npc>

              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>

        <section class="question">
          <div class="container">

            <!-- 要改的內容 -->
            <question-part hint="繞著警察署走看看，排除掉窗框和牆壁顏色不符合的選項吧。" morehint="總共有四種窗戶屬於警察署。" custom-answer>
              <p>請選出符合彰化警察署（現警察局彰化分局）建築外觀的照片。(複選)</p>
              <div class="row no-gutters">
                <div class="col-4" v-for="n in 9" :key="'puzzle'+n">
                  <a href="#" @click.prevent="toggleSelected(n-1)" class="puzzle-pic" :class="{'active': puzzleSelected[n-1]}">
                    <img :src="require(`@/assets/images/pics/puzzle${n}.jpg`)" class="img-fluid"/>
                  </a>
                </div>
              </div>
              <div class="mt-3">
                <button class="btn btn-danger btn-block" @click="answer">
                  回答
                </button>
              </div>
            </question-part>
            <!-- 要改的內容到此 -->

          </div>
        </section>

        <b-modal ref="wrongModal" hide-footer title="好像...弄錯了" header-bg-variant="dark" header-text-variant="white" body-bg-variant="dark"
 body-text-variant="white">
          <npc :npc-id="1" right>奇怪，怎麼走了這麼久還沒出去？</npc>
          <npc :npc-id="0">或許我們選錯了，再試一次看看吧。</npc>
        </b-modal>

      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage5_3',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第五章 - 3',
      isQuestion: true,
      stageId: 'time',
      puzzleSelected: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ]
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    toggleSelected: function(index) {
      this.$set(this.puzzleSelected, index, !this.puzzleSelected[index]);
    },
    answer: function() {
      if (
        !this.puzzleSelected[0] &&
        !this.puzzleSelected[1] &&
        !this.puzzleSelected[2] &&
        this.puzzleSelected[3] &&
        !this.puzzleSelected[4] &&
        !this.puzzleSelected[5] &&
        this.puzzleSelected[6] &&
        this.puzzleSelected[7] &&
        this.puzzleSelected[8]
      ) {
        window.location.href = `./現實`;
      } else {
        this.$refs['wrongModal'].show();
      }
    }
  }
}
</script>

<style scoped>
.puzzle-pic {
  display: block;
  border: solid 2px #ddd;
  transition: border .2s ease;
}

.puzzle-pic.active {
  border: solid 4px #e22;
}
</style>
